import styled, { css, keyframes } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Stack } from "@similarweb/ui-components/foundations";

const CARD_ENTER_DURATION_MS = 450;
const CARD_ENTER_STAGGER_MS = 90;
const CARD_ENTER_MAX_STAGGERED_INDEX = 5;

const cardEnter = keyframes`
    from {
        opacity: 0;
        transform: translateY(12px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: none;
    }
`;

export const AnimatedContactWidgetWrapper = styled.div<{ $index: number; $isAnimated: boolean }>`
    ${({ $index, $isAnimated }) =>
        $isAnimated &&
        css`
            animation: ${cardEnter} ${CARD_ENTER_DURATION_MS}ms cubic-bezier(0.22, 1, 0.36, 1) both;
            animation-delay: ${Math.min($index, CARD_ENTER_MAX_STAGGERED_INDEX) * CARD_ENTER_STAGGER_MS}ms;

            @media (prefers-reduced-motion: reduce) {
                animation: none;
            }
        `}
`;

export const StyledContactWidget = styled.div`
    width: 253px;
    min-height: 144px;
    height: fit-content;
    background: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 16px;
    margin: 0 16px 16px 0;
    padding: 16px 16px 4px 16px;
    box-sizing: border-box;
`;

export const TruncatableTitleWrapper = styled(Box)`
    min-width: 0;
    flex: 1;
`;

export const ShrinkableStack = styled(Stack)`
    min-width: 0;
`;

export const ShrinkableFlex = styled(Flex)`
    min-width: 0;
`;

export const StyledContactWidgetSkeleton = styled(StyledContactWidget)<{ top?: string; left?: string }>`
    position: absolute;
    height: 144px;
    padding: 16px;
    top: ${({ top }) => top || "0"};
    left: ${({ left }) => left || "0"};
`;
